import { defineStore } from 'pinia'

export const useAnnouncementStore = defineStore('AnnouncementStore', {
    state: () => ({
        banners: [],
    }),
    actions: {
        fetchActiveBanners() {
            return axios.get('/api/announcements/active')
                .then(response => {
                    this.banners = response.data.data.map(item => item.data)
                })
                .catch(() => {
                    this.banners = []
                })
        },
    },
})
